import React, { useEffect, useState } from 'react';
import { Menu, X, Droplets, Phone } from 'lucide-react';
import { Button } from './ui/button';

const links = [
  { label: 'Home', href: '#home' },
  { label: 'Technology', href: '#how' },
  { label: 'Product Range', href: '#products' },
  { label: 'Hotels', href: '#hotels' },
  { label: 'Yachts', href: '#yachts' },
  { label: 'Contact', href: '#contact' }
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-white/90 backdrop-blur-lg shadow-sm border-b border-sky-100' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#home" className="flex items-center gap-2 group">
          <div className="relative w-10 h-10 rounded-full bg-gradient-to-br from-sky-400 to-cyan-600 flex items-center justify-center shadow-lg shadow-sky-200 group-hover:scale-105 transition-transform">
            <Droplets className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl font-bold text-slate-900">Upgrade<span className="water-text">Water</span></div>
            <div className="text-[10px] tracking-[0.2em] text-sky-700/70 uppercase">Air • to • Water</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="nav-link text-sm font-medium text-slate-700 hover:text-sky-700">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="tel:+911800WATER" className="flex items-center gap-2 text-sm text-slate-600 hover:text-sky-700 transition-colors">
            <Phone className="w-4 h-4" /> 1800-UPGRADE
          </a>
          <Button className="btn-primary bg-gradient-to-r from-sky-500 to-cyan-600 hover:from-sky-600 hover:to-cyan-700 text-white rounded-full px-6 shadow-lg shadow-sky-200" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
            Book Free Demo
          </Button>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6 text-slate-800" /> : <Menu className="w-6 h-6 text-slate-800" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-sky-100 shadow-xl">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2 text-slate-700 font-medium hover:text-sky-700">{l.label}</a>
            ))}
            <Button className="bg-gradient-to-r from-sky-500 to-cyan-600 text-white rounded-full mt-2" onClick={() => { setOpen(false); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}>Book Free Demo</Button>
          </div>
        </div>
      )}
    </header>
  );
}
